import { useDrag, useDrop } from 'react-dnd';
import { DragItemType } from './dragItemTypes';

type CanDropTest = (dragItem: Record<string, any>, dropItem: Record<string, any>) => boolean;
export type DropFunction = (dragItem: Record<string, any>, dropItem: Record<string, any>) => void;

export function useDragDrop({ type, dragItem, canDrop, handleDrop }: { type: DragItemType, dragItem: Record<string, any> | (() => Record<string, any>), canDrop?: CanDropTest, handleDrop?: DropFunction}) {
	const [{ isDragging }, dragSourceRef, dragPreviewRef] = useDrag({
		type,
		item: typeof dragItem === 'function'? dragItem(): dragItem,
		collect: (monitor) => {
			return { isDragging: monitor.isDragging() }
		}
	});
	const [{ dropItem }, dropTargetRef] = useDrop({ 
		accept: type,
		collect: (monitor) => {
			return { dropItem: ((monitor.isOver() && monitor.canDrop()) ? monitor.getItem() : null) as any }
		},
		canDrop:  (item) => {
			if (canDrop) {
				return canDrop(item, dragItem);
			}

			return true;
		},
		drop: (item) => {
			if(handleDrop && (!canDrop || canDrop(item, dragItem))) {
				handleDrop(item, dragItem);
			}
		}
	});

	return [{isDragging, dragSourceRef, dragPreviewRef, dropItem, dropTargetRef}];
}	